<template>
  <modal :name="modalName" width="280px" height="450px" @before-open="beforeOpen" @before-close="beforeClose">
      <v-card>
          <v-card-title>
              <span class="headline">본인 사진(썸네일)</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="width: 250px; height: 330px;">
              <img
                      alt="등록된 사진이 없습니다"
                      :src="thumbnailPath"
                      width="200px"
                      height="200px"
              />
          </v-card-text>
          <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn color="blue darken-1" flat @click="showThumbnailGenerateModal">create</v-btn>
              <v-btn color="blue darken-1" flat @click="closeModal">Close</v-btn>
          </v-card-actions>
      </v-card>

    <ModalDriverImageThumbnailGenerator></ModalDriverImageThumbnailGenerator>
  </modal>
</template>

<script>
  import ModalDriverImageThumbnailGenerator from './modal-driver-image-thumbnail-generator';

  export default {
    components: {
      ModalDriverImageThumbnailGenerator
    },
    data : function() {
      return {
        driverId: null,
        thumbnailPath: null
      }
    },
    props : {
      modalName: {
        required: false,
        default: 'modal-driver-image-thumbnail',
      }
    },
    methods: {
      beforeOpen (e) {
        this.driverId = e.params.driverId;

        // TODO 이미지 갱신문제 확인
        this.thumbnailPath = apiHost.adminApiHost + '/attach/view/DRIVER_PICTURE_THUMBNAIL/' + this.driverId + '?v' + Math.random();
      },
      beforeClose () {
        this.clearModalData();
      },
      clearModalData() {
        this.driverId = null;
        this.thumbnailPath = null;
      },
      closeModal () {
        this.beforeClose();
        this.$modal.hide(this.modalName);
      },
      showThumbnailGenerateModal () {
        this.$modal.show('modal-driver-image-thumbnail-generator', {driverId : this.driverId});
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/modal/modal-driver-image-thumbnail.vue